import { Skeleton } from "@/components/ui/skeleton";

export const ProductCatalogSkeletonHeader = () => {
    return(
        <div className="flex flex-col gap-4">        
            <Skeleton className="w-[200px] h-[20px] rounded-sm" />
            <Skeleton className="w-full h-36  rounded-sm" />            
        </div>

    )
}

export const ProductCatalogSkeleton:React.FC<{isMobile?:boolean}> = ({isMobile}) => {
    const data = Array.from({ length: 10 });
    return (        
    <div className="flex flex-col flex-1 p-2 text-sm gap-4">
        <div className="flex flex-row justify-center lg:justify-between ">            
            {isMobile ? (
                <Skeleton className="py-2 w-[80dvw]  h-7 rounded-sm"/>):(
                <>
                    <Skeleton className="py-2 w-[10dvw]  h-7 rounded-sm"/>
                    <Skeleton className="py-2 w-[10dvw]  h-7 rounded-sm"/>
                </>
            )}
            
        </div>
        <div className="flex flex-row flex-wrap gap-8 justify-center">
            {
            data?.map( (_, index) => {                        
                return (
                    <Skeleton key={index} className="w-80 h-80 rounded-sm" />
                );
            })}                        
        </div>
        {/* <Paginator pages={pages} search_params={search_params} currentPage={currentPage}/> */}
    </div>);
}



